const COMPONENT_NAME = "FSAEligibleInfo";
export {
  COMPONENT_NAME
};
